import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Quote } from 'lucide-react';
const testimonials = [{
  id: 1,
  quote: "Invigo Technology completely transformed our legacy infrastructure. Their team's professionalism and deep technical expertise ensured a seamless migration with zero downtime.",
  name: 'Dr. Amina Bello',
  title: 'Director of IT',
  company: 'Federal Ministry of Health'
}, {
  id: 2,
  quote: 'The systems integration project delivered by Invigo has increased our operational efficiency by over 40%. They are a true partner who understands the African business landscape.',
  name: 'Chukwudi Okafor',
  title: 'Chief Operations Officer',
  company: 'Zenith Logistics'
}, {
  id: 3,
  quote: "From network design to deployment, Invigo's attention to detail is unmatched. Their managed services have given us peace of mind to focus on our core business.",
  name: 'Sarah Johnson',
  title: 'Head of Infrastructure',
  company: 'Pan-African Telecoms'
}];
export function TestimonialSlider() {
  const [currentIndex, setCurrentIndex] = useState(0);
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentIndex(prev => (prev + 1) % testimonials.length);
    }, 6000);
    return () => clearInterval(timer);
  }, []);
  return <div className="relative max-w-4xl mx-auto px-4" data-id="element-149">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 text-tech-green/20 z-0" data-id="element-150">
        <Quote className="w-32 h-32 rotate-180" data-id="element-151" />
      </div>

      <div className="relative z-10 min-h-[250px] flex items-center justify-center" data-id="element-152">
        <AnimatePresence mode="wait" data-id="element-153">
          <motion.div key={currentIndex} initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} exit={{
          opacity: 0,
          y: -20
        }} transition={{
          duration: 0.5
        }} className="text-center" data-id="element-154">
            <p className="text-xl md:text-2xl text-slate-700 font-medium leading-relaxed mb-8 italic" data-id="element-155">
              "{testimonials[currentIndex].quote}"
            </p>
            <div data-id="element-156">
              <h4 className="text-lg font-bold text-navy-900" data-id="element-157">
                {testimonials[currentIndex].name}
              </h4>
              <p className="text-sm text-slate-500" data-id="element-158">
                {testimonials[currentIndex].title},{' '}
                <span className="text-tech-blue font-medium" data-id="element-159">
                  {testimonials[currentIndex].company}
                </span>
              </p>
            </div>
          </motion.div>
        </AnimatePresence>
      </div>

      <div className="flex justify-center gap-2 mt-8" data-id="element-160">
        {testimonials.map((_, idx) => <button key={idx} onClick={() => setCurrentIndex(idx)} className={`w-2.5 h-2.5 rounded-full transition-all duration-300 ${idx === currentIndex ? 'bg-tech-green w-8' : 'bg-slate-300 hover:bg-slate-400'}`} aria-label={`Go to slide ${idx + 1}`} data-id="element-161" />)}
      </div>
    </div>;
}